var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-menu",style:(_vm.styles),on:{"click":function () { return _vm.$events.$emit('OPEN_DRAWER'); }}},[_c('div'),_c('div'),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }